import { Model, Phase } from "@gaming/srvg-classes-core";
import { Chunk } from "../Data/Chunk";

export const CHUNK_MODEL_CHUNK = 'chunk';

export class ChunkModel extends Model {
    chunk: Chunk;
    currentPhase: Phase;

    constructor() {
        super();
        this.chunk = null;
    }

    setChunk( chunk: Chunk ) {
        //console.log( 'current chunk', chunk );
        this.setProperty( CHUNK_MODEL_CHUNK, chunk );
    }

    destroy() {
        this.chunk = null;
        super.destroy();
    }
}